import React from 'react'
import { securityData } from '@/config/securityData'
import { Hero2Column } from '@/components/sections/Hero/Hero2Column'
import { CTA, TabSection } from '@/components/sections'
import BentoGrid from '@/components/sections/BentoGrid/BentoGrid'
import { TrustCard } from '@/components/sections/TrustCard'
import { recognitionBadges } from '@/config/homeData'

const Security = () => {
  // Prepare badges with improved images from homeData
  const complianceBadges = recognitionBadges.security.map(badge => ({
    logo: badge.src,
    title: badge.alt.replace(' Certified', '').replace(' Compliant', '')
  }));

  return (
    <div className="text-center md:text-left">
        <Hero2Column
          title={securityData.hero.title}
          subtext={securityData.hero.description}
          image={securityData.hero.backgroundImage}
          tag={securityData.hero.tag.text}
          tagHref={securityData.hero.tag.href || '#'}
          buttonText={securityData.hero.cta.primary.text}
          buttonHref={securityData.hero.cta.primary.href}
          secondaryButtonText={securityData.hero.cta.secondary.text}
          secondaryButtonHref={securityData.hero.cta.secondary.href}
          />

         <BentoGrid
          title={securityData.bentoGrid.title}
          subtitle={securityData.bentoGrid.subtitle}
          securityFeatures={securityData.bentoGrid.securityFeatures}
          complianceTitle={securityData.bentoGrid.compliance.title}
          complianceDescription={securityData.bentoGrid.compliance.description}
          complianceBadges={complianceBadges}
        />

        <TabSection
          title={securityData.tabSection.title}
          subtitle={securityData.tabSection.subtitle}
          description={securityData.tabSection.description}
          tag={securityData.tabSection.tag}
          tabs={securityData.tabSection.tabs}
          tabContent={securityData.tabSection.tabContent}
        />

        <TrustCard
          title={securityData.trustCard.title}
          description={securityData.trustCard.description}
          ctaText={securityData.trustCard.ctaText}
          ctaHref={securityData.trustCard.ctaHref}
          link1Text={securityData.trustCard.link1Text}
          link1Href={securityData.trustCard.link1Href}
          link2Text={securityData.trustCard.link2Text}
          link2Href={securityData.trustCard.link2Href}
        />

       <CTA
        title={securityData.cta.title}
        description={securityData.cta.description}
        cta={securityData.cta.cta}
      />

      </div>
  )
}

export default Security